import React from 'react';

interface WaveDividerProps {
  from?: string;
  to?: string;
  flip?: boolean;
}

const WaveDivider: React.FC<WaveDividerProps> = ({
  from = 'var(--bg-primary)',
  to = 'var(--bg-secondary)',
  flip = false,
}) => {
  return (
    <div className={`wave-divider ${flip ? 'wave-divider-top' : ''}`} style={{ background: from }}>
      <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0,0 C360,60 1080,0 1440,50 L1440,60 L0,60 Z"
          fill={to}
        />
      </svg>
    </div>
  );
};

export default WaveDivider;
